import axios, {
  AxiosRequestConfig,
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import { message } from 'antd'
import { isNumber } from 'lodash-es'

import qs from 'qs'
import { getStorage } from './tools'
import { loginAgainConfirm } from './help'

export interface ResponseData<T> {
  data: T
  result?: T
  code?: number
  msg?: string
  success?: boolean
  message?: string
}

export enum ResCodeEnum {
  // 80015 查询资源是否被锁定
  RequestResourceLocked = 80015,
  // 80003 接口被锁定
  ResourceLocked = 80003,
  // 80016 项目正在初始化
  ProjectInitializing = 80016,
}

const enterprise = process.env.REACT_APP_ENTERPRISE
const isLubanEnterprise = enterprise === 'luban'

// development 环境基础地址
const getDevUrl = () => {

  // 鲁班保持原来的网关地址不变
  if (isLubanEnterprise) {
    return window.BASE_URL || 'http://192.168.13.141:83/gateway'
  }
  // 神猴单独走新的网关地址
  if (enterprise === 'shenhou') {
    return window.BASE_URL || 'http://192.168.13.148:8185/gateway'
  }
  // 其他企业默认使用鲁班的网关
  return window.BASE_URL || 'http://192.168.13.141:83/gateway'
}

// qa 环境基础地址
const getQaUrl = () => {
  // 鲁班保持原来的网关地址不变
  if (isLubanEnterprise) {
    return window.BASE_URL || 'http://192.168.13.141:83/gateway'
  }
  // 神猴单独走新的网关地址
  if (enterprise === 'shenhou') {
    return window.BASE_URL || 'http://192.168.13.148:8185/gateway'
  }
  // 其他企业默认使用鲁班的网关
  return window.BASE_URL || 'http://192.168.13.141:83/gateway'
}

// production 环境基础地址
const getProdUrl = () => {
  // 鲁班保持原来的网关地址不变
  if (isLubanEnterprise) {
    return window.BASE_URL || 'https://zjy.lubansoft.com/gateway'
  }
  // 神猴单独走新的网关地址
  if (enterprise === 'shenhou') {
    return window.BASE_URL || 'http://192.168.3.30:8185/gateway'
  }
  // 其他企业默认使用鲁班的网关
  return window.BASE_URL || 'https://zjy.lubansoft.com/gateway'
}

export type PlatformType = 'api' | 'centerApi' | 'custom' | 'none' | 'rcj' | '141' | 'document'
// http://192.168.13.140:8182/gateway
// 打包时根据自定义的环境变量 NODE_STAGE 选择不同的api
const ConfigApi = {
  // development: 'https://zjy-pre.lubansoft.com/gateway',
  development: getDevUrl(),
  // development: 'gateway',
  qa: getQaUrl(), // 测试

  // development: 'http://192.168.13.147:8185/gateway',
  // qa: 'http://192.168.13.147:8185/gateway', // 测试
  // development: 'http://222.71.50.180:8185/gateway',
  // qa: 'http://222.71.50.180:8185/gateway', // 测试

  // development: 'https://zjy.lubansoft.com/gateway',
  // development: 'http://192.168.13.141:83/gateway-147',
  // qa: 'http://192.168.13.141:83/gateway-147',

  pre: window.BASE_URL || 'https://zjy-pre.lubansoft.com/gateway', // 预发布环境
  production: getProdUrl(), // 线上
} as Record<string, string>

// center api配置
const ConfigCenterApi = {
  // development: 'https://zjy.lubansoft.com/gateway',
  development: 'http://192.168.13.140:8182/gateway',
  qa: 'http://192.168.13.140:8182/gateway', // 测试
  pre: window.BASE_URL || 'https://zjy-pre.lubansoft.com/gateway', // 预发布环境
  production: window.BASE_URL || 'https://zjy.lubansoft.com/gateway', // 线上
} as Record<string, string>

// 人材机
const ConfigRcjApi = {
  // development: 'https://zjy.lubansoft.com/gateway',
  development: 'http://192.168.13.150:8283',
  qa: 'http://192.168.13.150:8283', // 测试
  pre: window.BASE_URL || 'https://zjy-pre.lubansoft.com/gateway', // 预发布环境
  production: window.BASE_URL || 'https://zjy.lubansoft.com/gateway', // 线上
} as Record<string, string>

// 内网
const innerApi = {
  // development: 'https://zjy.lubansoft.com/gateway',
  development: 'http://192.168.13.141:3080',
  // development: 'http://localhost:3080',
  qa: 'http://192.168.13.150:8283', // 测试
  pre: window.BASE_URL || 'https://zjy-pre.lubansoft.com/gateway', // 预发布环境
  production: window.BASE_URL || 'https://zjy.lubansoft.com/gateway', // 线上
} as Record<string, string>
// 临时测试使用
const CostomConfigApi = {
  development: 'http://localhost:8387/',
  qa: 'http://localhost:8387/', // 测试
  pre: window.BASE_URL || 'https://zjy-pre.lubansoft.com/gateway', // 预发布环境
  production: window.BASE_URL || 'https://zjy.lubansoft.com/gateway', // 线上
} as Record<string, string>

// 资料编制
const ConfigDocumentApi = {
  development: 'http://192.168.13.141:83/gateway',
  qa: 'http://192.168.13.141:83/gateway', // 测试
  pre: window.BASE_URL || 'https://zjy-pre.lubansoft.com/gateway', // 预发布环境
  production: window.BASE_URL || 'https://zjy.lubansoft.com/gateway', // 线上
} as Record<string, string>

/**
 * 重组URL
 * @param path
 * @returns {string}
 */
export function getUrl(path: string, platform = 'api'): string {
  let baseUrl;
  // 临时测试
  // if (path.includes('cost-cloud-cloudproject') && process.env.NODE_STAGE === 'development') {
  //   console.log('path :>> ', path, '使用代理')
  //   return path; // 直接返回相对路径，让 setupProxy.js 的代理生效
  // }
  // console.log('path :>> ', path, baseUrl)
  if (platform === 'api') {
    baseUrl = ConfigApi[process.env.NODE_STAGE || 'development'];
  }
  if (platform === 'center') {
    baseUrl = ConfigCenterApi[process.env.NODE_STAGE || 'development'];
  }
  if (platform === 'custom') {
    baseUrl = ConfigApi[process.env.NODE_STAGE || 'development'];
  }
  if (platform === 'rcj') {
    baseUrl = ConfigRcjApi[process.env.NODE_STAGE || 'development'];
  }
  if (platform === '141') {
    baseUrl = innerApi[process.env.NODE_STAGE || 'development'];
  }
  if (platform === 'document') {
    baseUrl = ConfigDocumentApi[process.env.NODE_STAGE || 'development'];
  }
  if (platform === 'none') {
    return path
  }
  return `${baseUrl}${path}`;
}

// 指定 axios 请求主体类型
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 是否在跨域请求中发送凭据，如cookies或授权头
axios.defaults.withCredentials = true

// 添加请求拦截器
axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 获取用户token，用于校验
    if (!config.url?.includes('/login')) {
      const token = getStorage('token')
      if (token) {
        config.headers['access-token'] = token
      }
    }
    return config
  },
  (error: AxiosError) => Promise.reject(error),
)

// 添加响应拦截器，拦截登录过期或者没有权限
axios.interceptors.response.use(
  (response: AxiosResponse<ResponseData<any>>) => {
    const url = response.config.url
    // console.log('请求的 URL:', url)
    if (!response?.data?.code) {
      return response
    }
    const { code, msg } = response.data
    // 登录已过期，token失效  1007：当前账号已在其它地点登录~  
    if (code === 401 || code === 1002 || code === 1007 || code === 1021 || code === 1013) {
      loginAgainConfirm() // 重定向登录界面
      return Promise.reject(response)
    }
    // 错误码
    // 80003
    // 80015 判断项目是否被锁定
    const errCodes = [82011,
      403, 500, 1007, 40000, -119, 0, 50001, 50000, 1006, 1035, 1037, 1021, 400, -102, 1003, 1014, 1016, -1, 8005, 80003, 80005, 1015
    ]
    // const warningCodes = [80003]
    // 重置builder的错误信息 /cost-cloud-account/web/enterprises 这个接口返回消息需要单独处理
    if (code == 1015 && url.includes('/web/enterprises')) {
      response.data.msg = '当前用户没有可用授权~'
      response.data.message = '当前用户没有可用授权~'
    }
    if (code === 403) {
      message.error('没有当前功能权限，请联系管理员')
      return Promise.reject(response)
    }
    // 锁失效提示
    if (code == 8005) {
      response.data.msg = '锁失效，请重新获取锁'
      response.data.message = '锁失效，请重新获取锁'
    }

    if (isNumber(code) && errCodes.includes(code)) {
      message.error(response.data.msg || response.data.message)
      return Promise.reject(response)
    }
    return response
  },
  (error: AxiosError<ResponseData<any>>) => {
    console.log('error :>> ', error)
    try {
      const { response } = error
      // 请求被取消，不进行任何处理
      if (error?.code === 'ERR_CANCELED') {
        return Promise.reject(response)
      }
      const msgInfo = response?.data?.msg || response?.data?.message || '服务错误'
      // 处理不同网络状态码下的错误
      if (response?.status === 401) {
        message.error('没有当前功能权限，请联系管理员')
        // loginAgainConfirm() // 重定向登录界面
        return Promise.reject(response)
      }
      // 无response，有可能是接口跨域了
      if (!response) {
        // key避免多次提示
        message.error({ content: '服务错误', key: 'response-error' })
        return Promise.reject('服务错误')
      }
      if (response.status === 403) {
        message.error('没有当前功能权限，请联系管理员')
        return Promise.reject(response)
      }
      if (response.status === 400) {
        message.error(msgInfo)
        return Promise.reject(response)
      }
      if (response.status === 504) {
        message.error('服务器超时，请稍后再试')
        return Promise.reject(response)
      }
      return Promise.reject(response)
    } catch (e) {
      console.log('error', e)
    }
    return error
  },
)

interface ParamT {
  [name: string]: any
}

export async function request<T>(
  path: string,
  params?: ParamT | FormData,
  options?: AxiosRequestConfig,
  platform: PlatformType = 'api',
): Promise<T> {
  const url = getUrl(path, platform)
  const opts = {
    ...options,
    url,
    data: params,
  }
  // get, delete请求参数处理
  if (options.method.toLowerCase() === 'get' || options.method.toLowerCase() === 'delete') {
    const query = params ? `?${qs.stringify(params)}` : ''
    opts.url = `${url}${query}`
  }
  const axiosResult = await axios.request(opts)
  const responseBody = axiosResult?.data
  if (responseBody?.code == ResCodeEnum.RequestResourceLocked) {
    return responseBody as T
  }
  if (responseBody && Object.prototype.hasOwnProperty.call(responseBody, 'data')) {
    return responseBody.data as T
  }

  if (responseBody && Object.prototype.hasOwnProperty.call(responseBody, 'result')) {
    return responseBody.result as T
  }

  return responseBody as T
}

export function get<T>(
  path: string,
  params?: ParamT,
  config?: AxiosRequestConfig,
  platform: PlatformType = 'api'
) {
  return request<T>(path, params, {
    method: 'GET',
    ...config,
  }, platform);
}


export function post<T>(path: string, params?: ParamT, config?: AxiosRequestConfig, platform: PlatformType = 'api') {
  return request<T>(path, params, {
    method: 'POST',
    ...config,
  }, platform)
}

export function patch<T>(path: string, params?: ParamT, config?: AxiosRequestConfig, platform: PlatformType = 'api') {
  return request<T>(path, params, {
    method: 'PATCH',
    ...config,
  }, platform)
}

export function put<T>(path: string, params?: ParamT, config?: AxiosRequestConfig, platform: PlatformType = 'api') {
  return request<T>(path, params, {
    method: 'PUT',
    ...config,
  }, platform)
}

export function remove<T>(path: string, params?: ParamT, config?: AxiosRequestConfig, platform: PlatformType = 'api') {
  return request<T>(path, params, {
    method: 'DELETE',
    ...config,
  }, platform)
}

export default request
